import SubsectionMobile from "./SubsectionMobile";

export default SubsectionMobile;
export { SubsectionMobile };
